import { useAppConfigStore } from '@/js/stores/appConfig';
import { useAppOrdersStore } from '@/js/stores/appOrders';
import { useCommercialisationStore } from '@/js/stores/commercialisation';
import { useContractsStore } from '@/js/stores/contracts';
import { useExpeditionsStore } from '@/js/stores/expeditions';
import { useGisStore } from '@/js/stores/gis';
import { useGisEditorStore } from '@/js/stores/gisEditor';
import { usePresenceStore } from '@/js/stores/presence';
import { useProductionStore } from '@/js/stores/production';
import { useRepairPartsStore } from '@/js/stores/repairParts';
import { useTraceabilityStore } from '@/js/stores/traceability';

export function migrateDataFromVuexToPinia() {
  // Check for the existence of 'appConfig' key in Pinia local storage
  const piniaAppConfigData = localStorage.getItem('appConfig');
  if (piniaAppConfigData) {
    // No need for migration
    return;
  }

  try {
    const vuexStorage = localStorage.getItem('vuex');
    if (!vuexStorage) {
      return;
    }

    const vuexData = JSON.parse(vuexStorage);

    if (vuexData) {
      // Mapping between Vuex store names and Pinia store IDs
      const storeMappings = {
        APPConfigStore: useAppConfigStore(),
        AppOrders: useAppOrdersStore(),
        CommercialisationStore: useCommercialisationStore(),
        Contracts: useContractsStore(),
        Expeditions: useExpeditionsStore(),
        Gis: useGisStore(),
        GisEditor: useGisEditorStore(),
        PresenceStore: usePresenceStore(),
        ProductionStore: useProductionStore(),
        Repairs: useRepairPartsStore(),
        TrazabilityStore: useTraceabilityStore(),
      };

      // Migrate data from Vuex to Pinia stores
      for (const vuexStoreName in vuexData) {
        if (Object.hasOwn(vuexData, vuexStoreName)) {
          /** @type {import('pinia').StoreGeneric} */
          const store = storeMappings[vuexStoreName];
          const storeData = vuexData[vuexStoreName];

          if (store && storeData) {
            for (const prop in storeData) {
              if (Object.hasOwn(storeData, prop)) {
                // Prop must exist in the new Pinia store
                if (store[prop] !== undefined) {
                  store[prop] = storeData[prop];
                }
              }
            }
          }
        }
      }
    }
  } catch {
    // eslint-disable-next-line no-console
    console.error('Error migrating from Vuex to Pinia');
  }
}
